import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

const TabNavigation = ({ activeTab, onTabChange }) => {
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onTabChange(newValue);
    }
  };

  return (
    <Box sx={{ mb: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ToggleButtonGroup
        value={activeTab}
        exclusive
        onChange={handleChange}
        sx={{
          bgcolor: '#f5f5f5',
          borderRadius: 1,
          p: 0.5,
          '& .MuiToggleButton-root': {
            border: 'none',
            borderRadius: 1,
            px: 9,
            py: 1.5,
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.25,
            color: '#737373',
            '&.Mui-selected': {
              bgcolor: 'white',
              color: '#1f1f1f',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              '&:hover': {
                bgcolor: 'white',
              }
            },
            '&:hover': {
              bgcolor: 'transparent',
              color: '#1f1f1f',
            }
          }
        }}
      >
        <ToggleButton value={0}>
          UPGRADE PLAN
        </ToggleButton>
        <ToggleButton value={1}>
          PAYMENTS
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default TabNavigation;
